import { component as defineComponent } from 'flightjs'; // eslint-disable-line no-restricted-imports
import $ from 'jquery'; // eslint-disable-line no-restricted-imports

function LikeButton() {
    this.defaultAttrs({
        currentLikeCount: '[data-like-count]',
        inspirationCollectorEnabled: false,
        cookieKey: 'liked_designs',
    });

    this.getLikeCount = function() {
        return parseInt(this.select('currentLikeCount').text(), 10) || 0;
    };

    this.setLikeCount = function(count) {
        this.select('currentLikeCount').text(count);
    };

    this.isDesignLiked = function() {
        return this.$node.attr('data-liked') === 'true';
    };

    this.setDesignLiked = function(isLiked) {
        this.$node.attr('data-liked', `${isLiked}`);
    };

    this.setLikeStatusAndCount = function(isLiked, likeCount) {
        this.setDesignLiked(isLiked);
        this.setLikeCount(likeCount);

        if (this.attr.inspirationCollectorEnabled) {
            if (isLiked) {
                this.on(window, 'InspirationCollectorUpdated', this.onInspirationCollectorUpdate);
            } else {
                this.off(window, 'InspirationCollectorUpdated', this.onInspirationCollectorUpdate);
            }
        }
    };

    this.onDesignLikedSuccess = function(e, data) {
        this.setLikeStatusAndCount(true, data.likeCount);
    };

    this.onDesignUnlikedSuccess = function(e, data) {
        this.setLikeStatusAndCount(false, data.likeCount);
    };

    this.onInspirationCollectorUpdate = function(e) {
        const { liked, designId } = e.detail;

        if (designId === this.$node.attr('data-design-id') && !liked) {
            this.processUnlikeAction();
        }
    };

    this.dispatchLikeUpdated = function(liked) {
        if (this.attr.inspirationCollectorEnabled) {
            const designImage = $(`a[data-design-id="${this.$node.attr('data-design-id')}"] img`);
            const designSrc = designImage.attr('src');
            const designAlt = designImage.attr('alt');

            window.dispatchEvent(
                new CustomEvent('DesignLikeUpdated', {
                    detail: {
                        liked: liked,
                        designId: this.$node.attr('data-design-id'),
                        designerId: this.$node.attr('data-designer-id'),
                        categoryKey: this.$node.attr('data-category-key'),
                        industryKey: this.$node.attr('data-industry-key'),
                        designSrc,
                        designAlt,
                    },
                })
            );
        }
    };

    this.getInspirations = function() {
        return JSON.parse(localStorage.getItem('inspirations') || '[]');
    };

    this.getMaxDesignsInCollector = function() {
        return JSON.parse(localStorage.getItem('maxDesignsInCollector') || '10');
    };

    this.hasDesignBeenLiked = function() {
        let inspirations = this.getInspirations();
        return inspirations.find(design => design.designId === this.$node.attr('data-design-id'));
    };

    this.processLikeAction = function() {
        this.setLikeStatusAndCount(true, this.getLikeCount() + 1);
        if (!this.attr.inspirationCollectorEnabled) {
            this.trigger(this.$node, 'uiDesignLiked');
        }
    };

    this.processUnlikeAction = function() {
        this.setLikeStatusAndCount(false, this.getLikeCount() - 1);
        if (!this.attr.inspirationCollectorEnabled) {
            this.trigger(this.$node, 'uiDesignUnliked');
        }
    };

    this.toggle = function(e) {
        let inspirations = this.getInspirations();
        const designIdTooltip = document.getElementById(this.$node.attr('data-design-id'));
        if (designIdTooltip) {
            designIdTooltip.style.display = 'none';
        }
        e.preventDefault();
        if (this.isDesignLiked()) {
            this.processUnlikeAction();
            this.dispatchLikeUpdated(false);
        } else if (
            inspirations.length < this.getMaxDesignsInCollector() ||
            !this.attr.inspirationCollectorEnabled
        ) {
            this.processLikeAction();
            this.dispatchLikeUpdated(true);
        } else {
            if (designIdTooltip) {
                designIdTooltip.style.display = 'block';
            }
            this.dispatchLikeUpdated(true);
        }
    };

    this.after('initialize', function() {
        if (!this.attr.inspirationCollectorEnabled) {
            this.on(this.$node, 'dataDesignLikedSuccess', this.onDesignLikedSuccess);
            this.on(this.$node, 'dataDesignUnlikedSuccess', this.onDesignUnlikedSuccess);
        }

        if (this.attr.inspirationCollectorEnabled && this.hasDesignBeenLiked()) {
            this.setLikeStatusAndCount(true, this.getLikeCount() + 1);
        }

        this.on('click', this.toggle);
    });
}

export default defineComponent(LikeButton);



// WEBPACK FOOTER //
// ./src/js/component_ui/like.js